import { PartialBy } from '@payflip/utils';
import { Children, isValidElement, ReactNode } from 'react';
import { Drawer, DrawerOverlay, DrawerProps } from '../../atoms';
import { SideOverlayBackButton } from './components/side-overlay-back-button';
import { SideOverlayBody } from './components/side-overlay-body';
import { SideOverlayContent } from './components/side-overlay-content';
import { SideOverlayFooter } from './components/side-overlay-footer';
import { SideOverlayHeader } from './components/side-overlay-header';
import { SideOverlayHeaderExtra } from './components/side-overlay-header-extra';
import { SideOverlayHeaderImg } from './components/side-overlay-header-img';
import { SideOverlayHeading } from './components/side-overlay-heading';

export function SideOverlay({
  isOverlayOn = true,
  children,
  onClose,
  ...rest
}: PartialBy<DrawerProps, 'onClose'> & {
  isOverlayOn?: boolean;
  content?: ReactNode;
}): JSX.Element {
  let content: JSX.Element | null | ReactNode = children;

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }

    if (child.type === SideOverlayContent) {
      content = child;
    }
  });
  return (
    <Drawer
      data-testid="side-overlay"
      closeOnOverlayClick={false}
      closeOnEsc={false}
      placement="right"
      size="sm"
      onClose={onClose ?? ((): null => null)}
      {...rest}
    >
      {isOverlayOn && <DrawerOverlay />}
      {content}
    </Drawer>
  );
}

SideOverlay.Body = SideOverlayBody;
SideOverlay.Footer = SideOverlayFooter;
SideOverlay.Header = SideOverlayHeader;
SideOverlay.Heading = SideOverlayHeading;
SideOverlay.Content = SideOverlayContent;
SideOverlay.BackButton = SideOverlayBackButton;
SideOverlay.HeaderExtra = SideOverlayHeaderExtra;
SideOverlay.HeaderImg = SideOverlayHeaderImg;
